var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitchlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.99095 -0.00480652L-0.00378418 5.14475V26.1916H7.08713V29.9952H11.0766L14.8407 26.1916H20.6062L28.3599 18.3568V-0.00480652H1.99095ZM25.7024 17.0108L21.2689 21.4907H14.178L10.4139 25.2943V21.4907H4.42969V2.68046H25.7024V17.0108ZM21.2689 7.83001V15.6581H18.6115V7.83001H21.2689ZM14.178 7.83001V15.6581H11.5206V7.83001H14.178Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.3636,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchlogo);
export default __webpack_public_path__ + "static/media/twitch logo.002733ffff0b9e108161d7857feceadb.svg";
export { ForwardRef as ReactComponent };